var redirect = {

	/**
	 * Initialize redirect functionality by handling redirect elements in the target
	 * Looks for elements with data-redirect-url attribute
	 *
	 * @param {HTMLElement} target - The DOM element to search for redirect elements
	 * @returns {void}
	 */
	init: function(target) {
		redirect.handleRedirectElement(target);
	},

	/**
	 * Finds redirect elements and extracts their parameters to trigger redirection
	 * Looks for data-redirect-url, data-redirect-enabled and data-redirect-delay attributes
	 *
	 * @param {HTMLElement} target - The DOM element to search for redirect elements
	 * @returns {void}
	 */
	handleRedirectElement: function(target) {
		var elements = target.querySelectorAll('[data-redirect-url]');
		if (elements.length > 1) {
			console.warn('Multiple redirect elements found. Only the first one will be processed.');
		}
		if (typeof elements[0] !== 'undefined' && elements[0] !== null) {
			var link = elements[0].getAttribute('data-redirect-url');
			var enabled = elements[0].getAttribute('data-redirect-enabled') || 1;
			var delay = elements[0].getAttribute('data-redirect-delay') || 0;
			if (link && link.trim() !== '') {
				redirect.gotoUrl(link, enabled, delay);
			}
		}
	},

	/**
	 * Redirects the browser to a specified URL after an optional delay
	 * Only redirects if enabled parameter evaluates to true
	 *
	 * @param {string} link - The URL to redirect to
	 * @param {string|number|boolean} enabled - Whether the redirect should occur. Defaults to 1
	 * @param {string|number} delay - Delay in milliseconds before redirect occurs. Defaults to 0
	 * @returns {void}
	 */
	gotoUrl: function(link, enabled = 1, delay = 0) {
		if (typeof enabled !== 'undefined' && enabled !== false) {
			if ((parseInt(enabled) == 1) || (enabled == true)) {
				window.setTimeout(function() {
					window.location.href = link;
				}, delay);
			}
		}
	}

};

export default redirect;
